import React, { PropTypes } from 'react';
import config from 'config';
import AbstractEditForm from '../../../common/AbstractEditForm';
import FullDatePicker from '../../../form/FullDatePicker';
import InputToggle from '../../../form/InputToggle';
import Input from '../../../form/Input';
import RaisedButton from 'material-ui/RaisedButton';
import ImageUpload from '../../../form/ImageUpload';
import { Container, Row, Col } from 'react-grid-system';
import Countries from '../../../form/Countries';
import RichEditor from '../../../form/RichEditor/index';

class StreamEdit extends AbstractEditForm {
  static propTypes = {
    ...AbstractEditForm.propTypes,
    fields: PropTypes.objectOf({
      title: PropTypes.object,
      countries: PropTypes.object,
      description: PropTypes.object,
      m3u8: PropTypes.object,
      m3u8_backup: PropTypes.object,
      startDate: PropTypes.object,
      endDate: PropTypes.object,
      is_live: PropTypes.bool,
      trigger_push_notifications: PropTypes.bool,
      push_notifications_triggered: PropTypes.bool,
      logo: PropTypes.object
    })
  };

  state = {
    toggle: false
  };

  static contextTypes = {
    muiTheme: PropTypes.object
  };

  publish = () => {
    return this.props.handleSubmit(async data => {
      await this.props.publish(this.props.model, data);
      return this.props.onClose();
    })(this.props.values);
  };

  streamStatus() {
    let {
      fields: { startDate, is_live }
    } = this.props;

    if (startDate.value > new Date()) {
      is_live.checked = false;
      is_live.value = false;
      return true;
    }
    return false;
  }

  pushStatus() {

    let { fields: { title } } = this.props;
    if (title === '') return false;

    return true;
  }

  streamEndStatus() {
    let {
      fields: { endDate }
    } = this.props;
    if (endDate.value !== '') return !isNaN(endDate.value.getTime());
  }

  _streamToggleLabelStatus() {
    let {
      fields: { startDate, is_live }
    } = this.props;
    if (startDate.value > new Date()) {
      return 'Stream can\'t be activated now, it has future start date';
    } else if (is_live) {
      return is_live.value ? 'Stream is active' : 'Stream is inactive';
    }
  }

  _pushToggleLabelStatus() {
    let { fields: { trigger_push_notifications } } = this.props;
      return trigger_push_notifications.value ? 'Send push notifications' : 'Do not send push notifications';
  }

  _streamToggleLabelVIPStatus() {
    let {
      fields: { vip_only }
    } = this.props;

    if (vip_only) {
      return vip_only.value ? 'VIP-only ' : 'Free';
    }
  }

  streamToggleLabelStyle() {
    let { muiTheme } = this.context;
    let {
      fields: { startDate, is_live }
    } = this.props;
    if (startDate.value > new Date()) {
      return {
        color: muiTheme.textField.errorColor
      };
    } else if (is_live) {
      return {
        color: muiTheme.textField.hintColor
      };
    }
  }

  pushToggleLabelStyle() {
    let { muiTheme } = this.context;
    let {
      fields: { startDate, trigger_push_notifications }
    } = this.props;
    if (startDate.value > new Date()) {
      return {
        color: muiTheme.textField.errorColor
      };
    } else if (trigger_push_notifications) {
      return {
        color: muiTheme.textField.hintColor
      };
    }
  }

  _getMinDateTime(data) {
    let minDate = new Date(data.getTime());
    if (minDate < new Date().getTime()) {
      minDate = new Date(data.getTime() + 60000);
    } else {
      minDate = data;
    }

    let {
      fields: { startDate }
    } = this.props;
    startDate.onChange(minDate);
  }


  render() {
    let {
      fields: {
        title,
        m3u8,
        m3u8_backup,
        is_live,
        trigger_push_notifications,
        push_notifications_triggered,
        startDate,
        logo,
        description,
        vip_only,
        countries
      },
      disabled,
      valid,
      dirty
    } = this.props;

    return (
      <form onSubmit={this.processSubmit} style={{ padding: 31 }}>
        {this._renderHeader()}
        <Container style={{ marginLeft: 0, padding: 0 }}>
          <Row>
            <Col lg={8} md={10} xs={12}>
              <Row>
                <Col xs={12}>
                  <ImageUpload
                    label="Stream Preview Picture"
                    required
                    disabled={
                      disabled || is_live.value || this.streamEndStatus()
                    }
                    imageWidth="auto"
                    imageHeight="300px"
                    crop={config.streamCrop}
                    {...logo}
                  />
                </Col>
                <Col xs={12}>
                  <Input
                    label="Add Stream Name"
                    required
                    disabled={
                      disabled || is_live.value || this.streamEndStatus()
                    }
                    {...title}
                  />
                </Col>
                <Col xs={12}>
                  <Input
                    label="Add Main Stream Link"
                    placeholder="http://example.com/link"
                    disabled={
                      disabled || is_live.value || this.streamEndStatus()
                    }
                    {...m3u8}
                  />
                </Col>
                <Col xs={12}>
                  <Input
                    label="Add Backup Stream Link"
                    placeholder="http://example.com/link"
                    disabled={
                      disabled || is_live.value || this.streamEndStatus()
                    }
                    {...m3u8_backup}
                  />
                </Col>
                <Col xs={12}>
                  <FullDatePicker
                    label="Add Start Time"
                    required
                    disabled={
                      disabled || is_live.value || this.streamEndStatus()
                    }
                    min={new Date()}
                    onchange={this._getMinDateTime}
                    {...startDate}
                  />
                </Col>
                <Col xs={12}>
                  <RichEditor
                    label="Add Description Text"
                    required
                    disabled={
                      disabled || is_live.value || this.streamEndStatus()
                    }
                    {...description}
                  />
                </Col>
                <Col xs={12}>
                  <Countries
                    label="Geographic Availability"
                    disabled={
                      disabled || is_live.value || this.streamEndStatus()
                    }
                    placeholder="Find country"
                    required
                    {...countries}
                  />
                </Col>
                <Col xs={12}>
                  <InputToggle
                    style={{ cursor: 'pointer', marginBottom: 20 }}
                    label={this._streamToggleLabelVIPStatus()}
                    {...vip_only}
                    disabled={disabled}
                    labelPosition="right"
                  />
                </Col>
                <Col xs={12}>
                  <InputToggle
                    style={{ cursor: 'pointer', marginBottom: 20 }}
                    label={this._streamToggleLabelStatus()}
                    labelStyle={this.streamToggleLabelStyle()}
                    {...is_live}
                    disabled={
                      disabled || this.streamStatus() || this.streamEndStatus()
                    }
                    labelPosition="right"
                  />
                </Col>
                <Col xs={12}>
                { push_notifications_triggered.value ? <p>'Push notifications are triggered'<br/></p> : <InputToggle
                    style={{ cursor: 'pointer', marginBottom: 20 }}
                    label={this._pushToggleLabelStatus()}
                    labelStyle={this.pushToggleLabelStyle()}
                    value={this.pushStatus()}
                    {...trigger_push_notifications}
                    disabled={ disabled }
                    labelPosition="right"
                  /> }
                </Col>
              </Row>
              <Row>
                <Col xs={6}>
                  <RaisedButton
                    secondary={true}
                    fullWidth={true}
                    disabled={!valid || !dirty || this.streamEndStatus()}
                    onClick={this.publish}
                    label="Save and Publish"
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </form>
    );
  }
}

export default StreamEdit;



// WEBPACK FOOTER //
// ./src/components/Stream/CustomStream/StreamEditForm/StreamEditForm.js